import { useMemo } from 'react';

import type { Camera } from 'types/camera';
import { SpotDetails } from 'types/spot';

const useCameraInsightsCamera = ({
  selectedCamera,
  spot,
}: {
  selectedCamera?: Camera;
  spot: SpotDetails;
}) => {
  const insightsCamera = useMemo(
    () =>
      selectedCamera?.supportsInsights && spot?.insightsCameraId
        ? selectedCamera
        : spot.cameras.find((camera) => camera._id === spot?.insightsCameraId),
    [selectedCamera, spot],
  );

  return insightsCamera;
};

export default useCameraInsightsCamera;
